<div class="contact-widget">
    <div class="container">
        <!-- <div class="row" style="margin-bottom: 15px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
                        <li class="breadcrumb-item"><a routerLink="/minha-area">Minha Área</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Extrato das Atas das Reuniões</li>
                    </ol>
                </nav>
            </div>
        </div>
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
                <p>Seja bem vindo(a) <b>{{nomeUsuario}}</b></p>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-right">
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="voltar()">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i> Voltar
                </button>
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="sair()"
                    style="cursor: pointer; margin-left: 10px;" ngbTooltip="Sair"><i class="fa fa-sign-out"></i>
                    Sair</button>
            </div>
        </div> -->
        <div class="row" style="margin-bottom: 30px;">
            <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="list-group" style="margin-top: 25px;">
                    <a style="cursor: pointer;" *ngFor="let item of conselhos" (click)="exibirAtas(item)"
                        class="list-group-item list-group-item-action"
                        [ngStyle]="{'color': idSelecionado === item.idConselho ? '#FFFFFF' : '#637282' }"
                        [class.active]="idSelecionado === item.idConselho">
                        {{item.nome}}
                        <i class="fa fa-hand-o-right pull-right text-right" aria-hidden="true" style="color: #FFFFFF;"
                            *ngIf="idSelecionado === item.idConselho"></i>
                    </a>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="list-group" style="margin-top: 25px;">
                    <a style="cursor: pointer;" *ngFor="let item of atas" (click)="baixarAta(item)"
                        [ngStyle]="{'color': idAtaSelecionado === item.idAta ? '#FFFFFF' : '#637282' }"
                        class="list-group-item list-group-item-action" [class.active]="idAtaSelecionado === item.idAta">
                        {{item.dataInclusao | date: 'dd/MM/yyyy'}}
                        <i class="fa fa-cloud-download pull-right text-right" aria-hidden="true" style="color: #FFFFFF;"
                            *ngIf="idAtaSelecionado === item.idAta"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>